import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { IntlProvider, FormattedMessage } from "react-intl";
import ReactGA from "react-ga";

import { makeStyles, withStyles } from "@material-ui/core/styles";
import { Container, FormControl, Select, MenuItem } from "@material-ui/core";
import LanguageIcon from "@material-ui/icons/Language";
import { InputBase } from "@material-ui/core";
import {
  MemoryRouter as Router,
  Switch,
  Route,
  useLocation,
  useHistory,
} from "react-router-dom";

// language package
import messages_tw from "./compiled-lang/tw.json";
import messages_en from "./compiled-lang/en.json";
import messages_jp from "./compiled-lang/jp.json";

// Custom Component
import "./App.css";
import actions from "./actions.js";
import Portal from "./components/Portal";
import Home from "./components/Home";
import CarList from "./components/CarList";
import POIList from "./components/POIList";
import MapViewer from "./components/MapViewer";
import Background from "./img/white-bg.png";

const fixedHeight = window.outerHeight;
const fixedWidth = window.outerWidth;

ReactGA.initialize("G-NVXNM2NYFH");
ReactGA.pageview(window.location.pathname + window.location.search);

const useStyles = makeStyles((theme) => ({
  root: {
    //backgroundImage: `url(${Background})`,
    //backgroundSize: "cover",
    width: fixedWidth,
    height: fixedHeight,
    padding: "0",
    margin: "0",
  },
}));

/* custom select input component for langSelect */
const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      //marginTop: theme.spacing(0),
    },
  },
  input: {
    className: "langSelect",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:focus": {
      borderRadius: 4,
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
    },
  },
}))(InputBase);

const useGetFunction = (apikey, KIOSK_ID) => {
  const dispatch = useDispatch();
  const [isComplete, setComplete] = useState(false);
  const [error, setError] = useState(null);
  const [getFunction, setGetFunction] = useState({});
  const [poiList, setPoiList] = useState([]);


  useEffect(() => {
    setError(null);

    const GETFUNCTION_URL =
      "https://analytics.sto-tek.com/_nodered/api/getFunction?apiKey="
      + apikey
      + '&KIOSK_ID=' + KIOSK_ID;
    const GETPOIS_URL = (apikey, building_id) => {
      return `https://stoparking.sto-tek.com/api/getpois?apiKey=${apikey}&building=${building_id}&floor=all`
    }

    fetch(GETFUNCTION_URL)
      .then((res) => {
        return res.json();
      })
      .then((json) => {
        var data = {}
        const buildingId = parseInt(json[0].id);
        const buildingCode = json[0].code;
        const floorTable = json[0].floor;
        const floorList = [];
        const photo_url = json[0].photo;
        floorTable.forEach((floor) => {
          floorList.push(parseInt(floor.id));
        });
        const KIOSK_poi_id = json[0].Kiosk_POI_ID;
        /* set apikey */
        dispatch({ type: actions.SET_APIKEY, apikey: apikey });
        /* set building_id */
        dispatch({ type: actions.SET_BUILDING_ID, buildingId: buildingId });
        /* set building_code */
        dispatch({
          type: actions.SET_BUILDING_CODE,
          buildingCode: buildingCode,
        });
        /* set floor list */
        dispatch({ type: actions.SET_FLOORTABLE, floorTable: floorTable });
        /* set floor list */
        dispatch({ type: actions.SET_FLOORLIST, floorList: floorList });
        /* set KIOSK poi id */
        dispatch({
          type: actions.SET_KIOSK_POI_ID,
          KIOSK_POI_ID: KIOSK_poi_id,
        });
        /* set Region LOGO photo url */
        dispatch({ type: actions.SET_REGION_LOGO, photo: photo_url });
        data = {
          apikey,
          building_id: buildingId,
          building_code: buildingCode,
          floor_table: floorTable,
          floor_list: floorList,
          default_kiosk_id: KIOSK_poi_id,
          region_photo: photo_url
        }

        /* get pois */
        var getpoi_url = GETPOIS_URL(apikey, buildingId)
        fetch(getpoi_url).then(res => res.json()).then(res_json => {
          console.log(res_json);
          if (res_json) {
            if (res_json.info) {
              setPoiList(res_json.info);
            }
          }
        })

        setGetFunction(data);
        setComplete(true);
      })
      .catch((err) => {
        setComplete(true);
        setError(err);
      });
  }, [apikey]);
  return { data: { getFunction, poiList }, isComplete, error };
};

function NaviButtons(props) {
  const history = useHistory();
  const location = useLocation();
  const handleBack = (history) => {
    if (history.index === 0) {
      /* top page: follow browser back */
      window.history.back();
    }
    history.goBack();
  };
  const handleHome = (history) => {
    history.push("/");
  };
  const isRootPage = location.pathname === "/";
  if (isRootPage) {
    return <div></div>;
  }
  return (
    <div className="naviButtonArea">
      <div className="naviButtonAreaLeft">
        <img
          alt="backButton"
          className="backButton"
          src="img/btn-back.png"
          onClick={() => {
            handleBack(history);
          }}
        />
      </div>
      <div className="naviButtonAreaRight">
        <img
          alt="homeButton"
          className="homeButton"
          src="img/btn-home.png"
          onClick={() => {
            handleHome(history);
          }}
        />
      </div>
    </div>
  );
}

const SelectLang = (props) => {
  const { lang } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  return (
    <div className={classes.langSelect}>
      <FormControl variant="outlined">
        <Select
          variant="outlined"
          defaultValue="tw"
          value={lang}
          onChange={(e) => {
            dispatch({ type: actions.SET_LANG, lang: e.target.value });
          }}
          input={<BootstrapInput />}
        >
          <MenuItem value="tw">中文</MenuItem>
          <MenuItem value="en">English</MenuItem>
          <MenuItem value="jp">日本語</MenuItem>
        </Select>
      </FormControl>
    </div>
  );
};

function App(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const lang = useSelector((state) => state.lang);
  const queryStr = window.location.search;
  const searchParam = new URLSearchParams(queryStr);
  const apikey = searchParam.get("apikey");
  const searchType = searchParam.get("type") || "pnr";
  const langParam = searchParam.get("lang");
  const SELF_KIOSK_ID = parseInt(searchParam.get("KIOSK_ID"));
  if (langParam) {
    dispatch({ type: actions.SET_LANG, lang: langParam });
  }
  if (SELF_KIOSK_ID) {
    dispatch({ type: actions.SET_SELF_KIOSK_ID, SELF_KIOSK_ID: SELF_KIOSK_ID });
  }
  dispatch({ type: actions.SET_SEARCHTYPE, searchType });
  const { data, isComplete, error } = useGetFunction(apikey, SELF_KIOSK_ID);
  const locale = {
    tw: messages_tw,
    en: messages_en,
    jp: messages_jp,
  };

  return (
    <IntlProvider locale={lang} messages={locale[lang]}>
      <Container justifyContent="center" alignItems="center">
        <Router>
          <Switch>
            <Route exact path="/" component={Portal} />
            <Route path="/Home" component={Home} />
            <Route path="/CarList" component={CarList} />
            <Route path="/List">
              <POIList data={data.poiList} getFunc={data.getFunction} kiosk_id={SELF_KIOSK_ID} />
            </Route>
            <Route path="/MapView" component={MapViewer} />
          </Switch>
          <NaviButtons />
        </Router>
      </Container>
    </IntlProvider>
  );
}

export default App;
